<template>
  <page title="Add ads page" backTo="/ads" size="is-desktop">
    <form @submit.prevent="handleSubmit" v-if="form">
      <div class="columns">
        <div class="column is-4">
          <div class="box">
            <b-field label="ADS type">
              <b-select placeholder="Choose a type" v-model="form.type" expanded>
                <option value="html">Html</option>
                <option value="pdf">Pdf</option>
                <option value="image">Image</option>
                <option value="video">Video</option>
              </b-select>
            </b-field>
          </div>

          <div class="box">
            <b-field label="ADS fit">
              <b-select placeholder="Choose a fit" v-model="form.fit" expanded>
                <option value="height">Height</option>
                <option value="width">Width</option>
              </b-select>
            </b-field>
          </div>

          <div class="box">
            <div v-if="screenShot">
              <img :src="screenShot.url" />
              <hr />
            </div>

            <b-field>
              <upload-image
                endpoint="/admin/api/adses/media"
                file-field-name="image"
                :additional="{
                  prefix: 'images/adses/screenshot_path',
                  format: 'jpg'
                }"
                @uploaded="i => screenShot = i"
              >
                <button
                  type="button"
                  class="button is-primary is-outlined is-small"
                  slot="trigger"
                >Upload Screenshot Image</button>
              </upload-image>
            </b-field>
          </div>
        </div>

        <div class="column is-8">
          <div class="box">
            <b-field label="ADS name">
              <b-input placeholder="ASD name" v-model="form.name"></b-input>
            </b-field>
          </div>

          <div class="box">
            <div v-if="image.url">
              <img :src="image.url" v-if="form.type == 'image'" />

              <div v-else-if="form.type == 'pdf'">
                {{image.path}}
                <br />
                <a :href="image.url" type="button" class="button" target="_blank">Preview</a>
              </div>

              <div v-else-if="form.type == 'html'">
                {{ image.path }}
                <a :href="image.url" target="_blank">Show</a>
              </div>

              <div v-else-if="form.type == 'video'">
                {{ image.path }}
                <a :href="image.url" target="_blank">Preview</a>
              </div>
              <hr />
            </div>

            <div v-if="form.type == 'image'">
              <div v-if="form.path">
                <img :src="image.url" />
                <hr />
              </div>
              <b-field label="Image upload">
                <upload-image
                  endpoint="/admin/api/adses/media"
                  file-field-name="image"
                  :additional="{
                    prefix: 'ads/pages/images',
                    format: 'jpg'
                  }"
                  @uploaded="i => image = i"
                >
                  <button
                    type="button"
                    class="button is-primary is-outlined is-small"
                    slot="trigger"
                  >Upload Image</button>
                </upload-image>
              </b-field>
            </div>

            <b-field v-else-if="form.type == 'pdf'" label="PDF upload">
              <upload-pdf
                endpoint="/admin/api/adses/media"
                file-field-name="pdf"
                :additional="{
                  prefix: 'ads/pages/pdfs',
                  format: 'pdf'
                }"
                @uploaded="i => image = i"
              >
                <button
                  type="button"
                  class="button is-primary is-outlined is-small"
                  slot="trigger"
                >Upload PDF File</button>
              </upload-pdf>
            </b-field>

            <b-field v-else-if="form.type == 'video'" label="Video upload">
              <upload-video
                endpoint="/admin/api/adses/media"
                file-field-name="video"
                :additional="{
                  prefix: 'ads/pages/video',
                  format: 'mp4'
                }"
                @uploaded="i => image = i"
              >
                <button
                  type="button"
                  class="button is-primary is-outlined is-small"
                  slot="trigger"
                >Upload video</button>
              </upload-video>
            </b-field>

            <b-field
              v-else-if="form.type == 'html'"
              label="HTML upload"
              message="'Index.html' file must be at root directory"
            >
              <upload-html
                endpoint="/admin/api/adses/media"
                file-field-name="zip"
                :additional="{
                  prefix: 'ads/pages/zips',
                  format: 'zip'
                }"
                @uploaded="i => image = i"
              >
                <button
                  type="button"
                  class="button is-primary is-outlined is-small"
                  slot="trigger"
                >Upload Zip</button>
                <hr />
              </upload-html>
            </b-field>

            <b-field v-else label="Select an ADS type first"></b-field>
          </div>
        </div>
      </div>

      <hr />
      <div class="is-pulled-right">
        <router-link to="/ads" class="button" :disabled="form.processing">Cancel</router-link>

        <button class="button is-primary" :class="{ 'is-loading': form.processing }">
          <b-icon icon="content-save"></b-icon>
          <span>Save</span>
        </button>
      </div>
    </form>
  </page>
</template>

<script>
import UploadImage from "./../../components/UploadImage";
import UploadVideo from "./../../components/UploadVideo";
import UploadHtml from "./../../components/UploadHtml";
import UploadPdf from "./../../components/UploadPdf";

export default {
  components: {
    UploadImage,
    UploadVideo,
    UploadHtml,
    UploadPdf
  },

  data() {
    return {
      banner: null,
      form: new window.Form({
        name: null,
        type: null,
        path: null,
        screenshot_path: null,
        fit: null
      }),
      image: {
        url: null,
        path: null
      },
      screenShot: {
        url: null,
        path: null
      }
    };
  },

  watch: {
    image() {
      this.form.path = this.image.path;
    },
    screenShot() {
      this.form.screenshot_path = this.screenShot.path;
    }
  },

  methods: {
    handleSubmit() {
      this.form.post(`/admin/api/adses`).then(response => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully saved."
        });
        if (response) {
          console.log(response);
        }

        this.$emit("saved", this.form);
        this.$router.push("/ads");
      });
    }
  }
};
</script>
